var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgIconLogout = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-3.75 -3.75)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,22.5h-4a2,2,0,0,1-2-2V6.5a2,2,0,0,1,2-2h4",
    fill: "none",
    stroke: "#2d2d33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24,20.5l5-5-5-5",
    transform: "translate(-6.5 -2)",
    fill: "none",
    stroke: "#2d2d33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,18h-12",
    transform: "translate(-3 -4.5)",
    fill: "none",
    stroke: "#2d2d33",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconLogout, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-logout.264736f4.svg";
export { ForwardRef as ReactComponent };